import script from "./DocSummaryPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocSummaryPage.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__